import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import includes from "lodash/includes";
import React, { useState } from "react";
import BSInput from "../../../common/js/components/BSInput";

const reportHeaders = {
    Standard: {
        title: "Standard",
    },
    Metro: {
        title: "Metro",
    },
    MapOverview: {
        title: "Map Overview",
    },
    "HalfMap-HalfProperty": {
        title: "Half-Map Half-Property",
    },
    IndividualDetail: {
        title: "Individual Detail",
    },
    Reference: {
        title: "Reference Full Page",
    },
    MarketingFlyer: {
        title: "Marketing Flyer",
    },
};

const StyledModalPaper = styled("div")(({ theme }) => ({
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: "none",
}));

const StyledInstruction = styled("div")({
    marginBottom: 20,
});

const ReportTitleModal = (props) => {
    const {
        brokerInfoReport,
        generateCompMetroReport,
        generateCompReport,
        generateListingReport,
        hasConfidentialComps,
        metroReport,
        reportStyle,
        reportTitleModal,
        reportType,
        setReportTitle,
        tab,
        toggleIncludeBrokerInfo,
        toggleReportTitleModal,
    } = props;

    const [propType, setPropType] = useState("industrial");
    const [mapView, setMapView] = useState("standard");
    const [acknowledgedConfidential, setAcknowledgedConfidential] = useState(false);

    const handleGenerateReport = (tab) => {
        toggleReportTitleModal(false);
        setReportTitle(null);
        setAcknowledgedConfidential(false);
        if (reportType === "Listing") {
            if (reportStyle === "Standard") {
                generateListingReport(
                    tab,
                    brokerInfoReport.include,
                    reportTitleModal.title !== null ? reportTitleModal.title : "Listings Availability Report",
                    reportStyle,
                    null
                );
            } else if (includes(["HalfMap-HalfProperty", "MapOverview"], reportStyle)) {
                generateListingReport(tab, false, reportTitleModal.title, reportStyle, mapView);
            } else {
                generateListingReport(tab, false, reportTitleModal.title, reportStyle, null);
            }
        } else if (reportType === "Comp") {
            if (!metroReport) {
                if (reportStyle === "Standard") {
                    generateCompReport(
                        tab,
                        brokerInfoReport.include,
                        reportTitleModal.title !== null ? reportTitleModal.title : "Comparables Report",
                        reportStyle,
                        null
                    );
                } else if (includes(["HalfMap-HalfProperty", "MapOverview"], reportStyle)) {
                    generateCompReport(tab, false, reportTitleModal.title, reportStyle, mapView);
                } else if (reportStyle === "MarketingFlyer") {
                    generateCompReport(tab, false, reportTitleModal.title, reportStyle, null);
                } else {
                    generateCompReport(tab, false, reportTitleModal.title, reportStyle, null);
                }
            } else {
                generateCompMetroReport(tab, brokerInfoReport.include, reportTitleModal.title, propType);
            }
        }
    };

    const handleCancelReport = () => {
        toggleReportTitleModal(false);
        toggleIncludeBrokerInfo(true);
        setReportTitle(null);
        setPropType("industrial");
        setAcknowledgedConfidential(false);
    };

    const handleInfoToggle = (value) => {
        if (value === "true") {
            toggleIncludeBrokerInfo(true);
        } else {
            toggleIncludeBrokerInfo(false);
        }
    };

    const handlePropToggle = (value) => {
        setPropType(value);
    };

    const handleMapViewToggle = (value) => {
        setMapView(value);
    };

    const handleConfidentialityAcknowledged = () => {
        setAcknowledgedConfidential(true);
    };

    return (
        <Modal aria-labelledby="report-title-modal" aria-describedby="set-report-title" open={reportTitleModal.open}>
            <StyledModalPaper style={getModalStyle()}>
                {reportType === "Comp" && hasConfidentialComps && !acknowledgedConfidential && (
                    <StyledInstruction>
                        <Typography variant="body1">
                            <h4 className="modal-title">
                                There are <span style={{ color: "red", fontWeight: "bold" }}>Confidential</span> Comps
                                selected in this report. Are you sure you would like to continue?
                                <br />
                                <br />
                            </h4>
                        </Typography>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Button variant="outlined" onClick={() => handleCancelReport()}>
                                    No
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleConfidentialityAcknowledged()}
                                >
                                    Yes
                                </Button>
                            </Grid>
                        </Grid>
                    </StyledInstruction>
                )}

                {(!hasConfidentialComps || acknowledgedConfidential) &&
                    (reportType === "Comp" && reportStyle === "Metro" ? (
                        <h4 className="modal-title" style={{ paddingBottom: "25px" }}>
                            Create A Metro Lease {reportType} Report
                        </h4>
                    ) : (
                        <h4 className="modal-title" style={{ paddingBottom: "25px" }}>
                            Create A {reportHeaders[reportStyle] ? reportHeaders[reportStyle]["title"] : reportStyle}{" "}
                            {reportType} Report
                        </h4>
                    ))}

                {(!hasConfidentialComps || acknowledgedConfidential) && reportStyle !== "MarketingFlyer" && (
                    <React.Fragment>
                        <StyledInstruction>
                            <Typography variant="body1">Enter an optional title for your report below.</Typography>
                        </StyledInstruction>
                        <BSInput
                            id="reportTitle"
                            value={reportTitleModal.title}
                            onChange={(e) => setReportTitle(e.target.value)}
                            placeholder="Enter report title..."
                            extraInputStyles={{ marginBottom: "-20px", marginTop: "30px" }}
                            defaultValue="Listings Report"
                        />
                    </React.Fragment>
                )}

                {(!hasConfidentialComps || acknowledgedConfidential) &&
                    (metroReport ? (
                        <FormControl rowcomponent="fieldset">
                            <RadioGroup
                                row
                                aria-label="include"
                                name="include"
                                value={propType}
                                onChange={(e) => handlePropToggle(e.target.value)}
                            >
                                <FormLabel component="legend" style={{ marginBottom: "5px", paddingTop: "15px" }}>
                                    Property Type
                                </FormLabel>
                                <FormControlLabel
                                    value="industrial"
                                    control={<Radio id="include" color="primary" />}
                                    style={{ marginRight: "83px" }}
                                    label="Industrial"
                                />
                                <FormControlLabel
                                    value="nonindustrial"
                                    control={<Radio id="include" color="primary" />}
                                    label="Non-Industrial"
                                />
                            </RadioGroup>
                        </FormControl>
                    ) : (
                        ""
                    ))}

                {(!hasConfidentialComps || acknowledgedConfidential) &&
                    (includes(["Standard", "Metro"], reportStyle) ? (
                        <FormControl rowcomponent="fieldset">
                            <RadioGroup
                                row
                                aria-label="include"
                                name="include"
                                value={brokerInfoReport.include}
                                onChange={(e) => handleInfoToggle(e.target.value)}
                                style={{ marginBottom: "25px" }}
                            >
                                <FormLabel component="legend" style={{ marginBottom: "5px", paddingTop: "15px" }}>
                                    Broker Info
                                </FormLabel>
                                <FormControlLabel
                                    value={true}
                                    control={<Radio id="include" color="primary" style={{ marginRight: "5px" }} />}
                                    label="Include Broker Info"
                                />
                                <FormControlLabel
                                    value={false}
                                    control={<Radio id="include" color="primary" />}
                                    label="Don't Include Broker Info"
                                />
                            </RadioGroup>
                        </FormControl>
                    ) : (
                        ""
                    ))}

                {(!hasConfidentialComps || acknowledgedConfidential) &&
                    (includes(["HalfMap-HalfProperty", "MapOverview"], reportStyle) ? (
                        <FormControl rowcomponent="fieldset">
                            <RadioGroup
                                row
                                aria-label="include"
                                name="include"
                                value={mapView}
                                onChange={(e) => handleMapViewToggle(e.target.value)}
                                style={{ marginBottom: "25px" }}
                            >
                                <FormLabel component="legend" style={{ marginBottom: "5px", paddingTop: "15px" }}>
                                    Map View
                                </FormLabel>
                                <FormControlLabel
                                    value="standard"
                                    control={<Radio id="include" color="primary" style={{ marginRight: "5px" }} />}
                                    label="Standard"
                                />
                                <FormControlLabel
                                    value="aerial"
                                    control={<Radio id="include" color="primary" />}
                                    label="Aerial"
                                />
                            </RadioGroup>
                        </FormControl>
                    ) : (
                        ""
                    ))}

                {(!hasConfidentialComps || acknowledgedConfidential) && (
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Button variant="outlined" onClick={() => handleCancelReport()}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={() => handleGenerateReport(tab)}>
                                Go
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </StyledModalPaper>
        </Modal>
    );
};

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

export default ReportTitleModal;
